document.addEventListener("DOMContentLoaded", function () {
  // Hide loading overlay when page is fully loaded
  function hideLoading() {
    const loadingElement = document.getElementById('privacy-loading');
    if (loadingElement) {
      loadingElement.classList.add('hidden');
      // Remove the element after transition completes
      setTimeout(() => {
        loadingElement.style.display = 'none';
      }, 300);
    }
  }
  
  // Hide loading after a short delay to ensure content is rendered
  setTimeout(hideLoading, 500);
  let lastOrientation = window.matchMedia("(orientation: portrait)").matches ? 'portrait' : 'landscape';
  let lastWidth = window.innerWidth;
  
  function handleOrientationChange() {
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;
    const currentOrientation = isPortrait ? 'portrait' : 'landscape';
    const currentWidth = window.innerWidth;
    
    // 方向变化且分辨率跨越1024px阈值时触发
    if (currentOrientation !== lastOrientation && 
        ((lastWidth <= 1024 && currentWidth > 1024) || 
         (lastWidth > 1024 && currentWidth <= 1024))) {
      console.log("屏幕方向变化且分辨率跨越1024px");
      // 执行回调函数，如重新布局
      window.location.reload()
    }
    
    // 更新记录值
    lastOrientation = currentOrientation;
    lastWidth = currentWidth;
  }
  
  // 防抖函数（300ms内停止旋转才触发）
  function debounce(func, wait) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, arguments), wait);
    };
  }
  
  // 监听事件
  window.addEventListener('orientationchange', debounce(handleOrientationChange, 300));
  if (!('onorientationchange' in window)) {
    window.addEventListener('resize', debounce(handleOrientationChange, 300));
  }
  if (document.body.offsetWidth >= 768) {
    document.querySelectorAll(".privacy-tab-link:not(.privacy-tab-link-cookie)").forEach(function (link) {
      link.addEventListener("click", function (e) {
        return;
        e.preventDefault();
        document.querySelectorAll(".privacy-tab-link").forEach(function (link) {
          link.classList.remove("active");
          link.nextElementSibling.classList.add("hidden");
        });
        this.classList.add("active");
        this.nextElementSibling.classList.remove("hidden");
        document.querySelectorAll(".privacy-content").forEach(function (wrap) {
          wrap.classList.add("hidden");
        });
        document
          .querySelector("#" + this.href.split("#")[1])
          .classList.remove("hidden");
      });
    });
    document.querySelectorAll(".privacy-sidebar li").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        document
          .querySelectorAll(".privacy-sidebar li")
          .forEach(function (link) {
            link.classList.remove("active");
          });
        this.classList.add("active");
        let id = this.querySelector("a").getAttribute("href");
        let top =
          document.querySelector(id).getBoundingClientRect().top +
          window.scrollY;

        window.scrollTo({
          top: top,
          behavior: "smooth",
        });
      });
    });
    let index = 0;
    const allH2Tag = document.querySelectorAll("#privacy-policy h2");
    console.log(allH2Tag)
    allH2Tag.forEach((v, i) => {
      v.setAttribute("id", "privacy-" + (Number(i) + 1));
    });
  }
  document.querySelector('.privacy-tab-link-mb').addEventListener('click', () => {
    document.getElementById('menu-list').classList.toggle('hidden');
  })
  let lastScrollTop = 0; // 存储历史位置
  window.addEventListener("scroll", function () {
    const sidebar = document.querySelector(".privacy-sidebar");
    const container = document.querySelector(".privacy-container-wrap");
    const scrollTop = window.scrollY;
    const containerTop = container.offsetTop;
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let w = document
      .querySelector(".privacy-sidebar")
      .getBoundingClientRect().width;
    document.querySelector(".privacy-sidebar-wrap").style.width = w + "px";
    if (document.body.offsetWidth > 1024) {
      if (scrollTop >= containerTop) {
        document.querySelector(".privacy-sidebar-wrap").classList.add("fixed");
      } else {
        document
          .querySelector(".privacy-sidebar-wrap")
          .classList.remove("fixed");
      }
      if (
        document.querySelector(".privacy-sidebar-wrap").getBoundingClientRect()
          .bottom >
        document.querySelector(".privacy-main-content").getBoundingClientRect()
          .bottom
      ) {
        document
          .querySelector(".privacy-sidebar-wrap")
          .classList.remove("fixed");
      } else {
        document.querySelector(".privacy-sidebar-wrap").classList.add("fixed");
      }
    }

    if (document.body.offsetWidth <= 1024) {
      // const headerHidden = document.querySelector(".section-header").classList.contains('shopify-section-header-hidden')
      // document.querySelector(".privacy-sidebar-wrap").style.top = headerHidden ? '0' : '46px';
      
      // if (scrollTop > 0 && scrollTop < 46) {
      //   document.querySelector(".privacy-sidebar-wrap").style.top = Number(46 - scrollTop) + 'px';
      // }
      // else if (scrollTop === 0) {
      //   document.querySelector(".privacy-sidebar-wrap").style.top = '46px';
      // }
      // else {
      //   document.querySelector(".privacy-sidebar-wrap").style.top = '0';
      // }
      
      if (currentScrollTop > lastScrollTop) {
        // console.log('⬇️ 向下滚动');
        document.querySelector(".mb-menu-header").style.top = '0';
      } else if (currentScrollTop < lastScrollTop) {
        // console.log('⬆️ 向上滚动');
        document.querySelector(".mb-menu-header").style.top = '46px';
      }
      
      lastScrollTop = currentScrollTop; // 更新历史位置
      if (
        document.querySelector("#cookie-policy").getBoundingClientRect().top < 0
      ) {
        document.querySelector(
          ".privacy-sidebar .privacy-sidebar-link:last-child"
        ).style.display = "block";
        document.querySelector(
          ".privacy-sidebar .privacy-sidebar-link:first-child"
        ).style.display = "none";
        document
          .querySelector(
            ".privacy-sidebar .privacy-sidebar-link:last-child .privacy-tab-link"
          )
          .classList.add("active");
        document
          .querySelector(
            ".privacy-sidebar .privacy-sidebar-link:first-child .privacy-tab-link"
          )
          .classList.remove("active");
      } else {
        document.querySelector(
          ".privacy-sidebar .privacy-sidebar-link:last-child"
        ).style.display = "none";
        document.querySelector(
          ".privacy-sidebar .privacy-sidebar-link:first-child"
        ).style.display = "block";
        document
          .querySelector(
            ".privacy-sidebar .privacy-sidebar-link:first-child .privacy-tab-link"
          )
          .classList.add("active");
        document
          .querySelector(
            ".privacy-sidebar .privacy-sidebar-link:last-child .privacy-tab-link"
          )
          .classList.remove("active");
      }
    }
  });
  if (document.body.offsetWidth <= 1024) {
    document.querySelector(".privacy-sidebar-wrap").classList.add("fixed");
    document.querySelector("#cookie-policy").classList.remove("hidden");
  }
});
